export default __webpack_public_path__ + "static/media/FIGHT OR DIE 2.749721e3.png";